<!-- 多个网点选择 -->
<template>
  <el-dialog title="网点选择" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template style="margin-top: 40px;">
      <div id="containt" style="margin: 0;">
        <div class="grid-height">
          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1"  height="390"
				class="is-pointer" v-bind="vxeOption"
				@resizable-change="$vxeTableUtil.onColumnWitchChange"
        @custom="$vxeTableUtil.customHandle"
        @checkbox-change="addDataTable"
        @checkbox-all="checkAll"
        @cell-dblclick="checkWithSubmit">

        <template #form>

<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
          :data="formData" @submit="searchEvent" @reset="searchEvent">
  <vxe-form-item title="网点名称:" field="brandName">
    <template v-slot>
      <el-input v-model="searchSiteName" size="small" clearable />
    </template>
  </vxe-form-item>
</vxe-form>
<div class="clearfix screen-btns">
  <div class="fr" style="display: inline-block;
float: right;
margin-top: -39px;">
    <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
                status="primary" plain>重置</vxe-button> -->
    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                @click="searchEvent">搜索</vxe-button>
  </div>
</div>
</template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <label id="labBtn" class="transverse">
			<div class="icon">
				<i class="el-icon-more"></i>
				<i class="el-icon-more"></i>
			</div>
		</label>
		<div class="multipleChoice">
			<el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
				<a class="allDel icon-quanbushanchu" @click="clearChecked()"></a>
				</el-tooltip>
			<div class="list">
				<div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
					<p>{{ checkRow.userName }}</p>
					<a class="el-icon-close" @click="clearTable1Select(index)"></a>
				</div>
			</div>
		</div>
    <span slot="footer" class="dialog-footer">
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import Ar from "element-ui/src/locale/lang/ar";

export default {
  name: 'saleConfigDialog',
  props: ['excludeList'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.initSetting();
  },

  mounted() {
    console.log(this.excludeList)
    if (this.excludeList) {
      this.formData.excludeId = this.excludeList.map(item => item.id)
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },


  data() {
    return {
      total: 0,
      filterText: '',
      data: [],

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        userName: "",
        excludeId: null,  // 排除id
        stat: 5,
        siteFloorLevel: null  // 网点层级
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      selectedRow: {
        id: '', name: ''
      }
    };
  },


  methods: {
    selectChangeEvent({records}) {
      this.selectedList = []
      records.forEach(item => {
        this.selectedList.push({id: item.id, name: item.itemName, code: item.itemCode})
      })
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },


    // commitRow() {
    //   if (this.selectedList.length === 0) {
    //     this.$message.warning('请先选中产品')
    //   } else {
    //     this.$emit('commit', this.selectedList)
    //     this.dialogClose()
    //   }
    // },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.formData.itemCode = this.searchItemCode
      this.formData.itemName = this.searchItemName
      this.formData.brandName = this.searchBrandName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchItemCode = ''
      this.searchItemName = ''
      this.searchBrandName = ''
      this.formData.itemCode = ''
      this.formData.itemName = ''
      this.formData.brandName = ''
      this.formData.current = 1
      this.formData.searchCount = false
      this.formData.bigCategoryId = ''
      this.formData.smallCategoryId = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },


    reloadTree() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    // 点击的树形 点
    handleNodeClick(node, data) {
      let id = data.data.id;
      if (data.level === 1) {
        this.formData.bigCategoryId = id;
        this.formData.smallCategoryId = '';
      } else {
        this.formData.smallCategoryId = id;
      }

      this.initTableList();
      this.flushed()
    },

    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.snUser.getPageDataUrl,
        param: this.formData,
        method: 'post',
        columns: [
        {type: "checkbox", width: 40, title: '', resizable: false, fixed: 'left'},

          { title: '网点名称', field: 'userName', width: 140, },
          { title: '简称', field: 'userShortName', width: 110, },
          { title: '服务中心', field: 'snSiteInfoDTO.orgName', width: 140 },
          { title: '联系方式', field: 'userMobile', width: 110, },
          { title: '地址', field: 'area', width: 280,
            slots: {
              default: ({ row }) => {
                return [
                  <div><span>{row.userProvince}{row.userCity}{row.userCounty}{row.userTown}</span></div>
                ]
              }
            }
          },
          { field: 'stat', title: '状态', width: 150, slots: {
              default: ({row}) => {
                if (row.stat == 1) {
                  return [
                    <div class="txt-status disable">
                      <span>待审核</span>
                    </div>
                  ];
                } else if (row.stat == 2) {
                  return [
                    <div class="txt-status disable">
                      <span>审核中</span>
                    </div>
                  ];
                } else if (row.stat == 3) {
                  return [
                    <div class="txt-status disable">
                      <span>审核驳回</span>
                    </div>
                  ];
                } else if (row.stat == 5) {
                  return [
                    <div class="txt-status ">
                      <span>已审核</span>
                    </div>
                  ];
                } else if (row.stat == 91) {
                  return [
                    <div class="txt-status disable">
                      <span>暂停</span>
                    </div>
                  ];
                } else if (row.stat == 92) {
                  return [
                    <div class="txt-status disable">
                      <span>暂挂</span>
                    </div>
                  ];
                } else if (row.stat == 98) {
                  return [
                    <div class="txt-status disable">
                      <span>撤消</span>
                    </div>
                  ];
                } else if (row.stat == 99) {
                  return [
                    <div class="txt-status disable">
                      <span>黑名单</span>
                    </div>
                  ];
                }
              }
            }
          },
          { field: 'createTime', title: '创建时间', width: 110 },
          { title: '创建人', field: 'createBy', width: 110, },
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },


    // 加载页面
    loadChildNode(node, resolve) {
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        console.log(data, "data.data的值"),
          resolve(
            data.data.map(item => {
              return {
                label: item.categoryName,
                id: item.id,
                leaf: Number(item.isChild) == 1 ? false : true,
              }
            })
          )
      });
    },

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: -40px !important;
    position: absolute !important;
    z-index: 9;
    background-color: #ffffff;
}
body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

    z-index: 99999;
}

</style>
